import { Record } from 'immutable';
import { LegalEntity } from './legal-entity';

const PaymentRequestActionDataRecord = Record({
  email: null,
  reason: null,
  details: null,
  legalEntity: null,
  attachmentId: null,
});

export class PaymentRequestActionData extends PaymentRequestActionDataRecord {
  email: string;
  reason: string;
  details: string;
  legalEntity: LegalEntity;
  attachmentId?: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-request-action-data.ts